// ローカル開発ノード(devserver)で配信されている画面かどうかの判定。
//
// PRODUCT_DEV-369 以降、開発ノードでは nginx が 1 オリジン配下の `/vite/<product>/` に
// 各 Vite dev サーバを振り分けている（unizo / portal / admin / dev-lab）。
// デプロイ済み環境（dev/stg/prod）はプロダクトごとに独立したオリジンのルート配信なので、
// pathname が `/vite/<product>/` で始まることはない。

// 例: "/vite/unizo/" "/vite/dev-lab/nodes" → true ／ "/" "/nodes" "/vite/" → false
const LOCAL_VITE_PATH = /^\/vite\/[^/]+\//;

// ビルド時に確定する配信ベース。ローカルは "/vite/<product>/"、デプロイ済みは "/"。
// pathname だけで判定すると、prod で `/vite/x/` を開かせるだけで分岐に入ってしまう
// （実害は 1 ホップ余分に回るだけだが、判定の根拠としては弱い）。ビルド時の値と AND を
// 取って、**prod ビルドでは絶対に true にならない**ようにする。
// `import.meta.env.BASE_URL` は各アプリの Vite が shared-ui のソースごと置換する
// （`utils/api.ts:336` も同じ書き方）。モジュール読み込み時に定数へ写すと
// テストから差し替えられなくなるので、呼び出しのたびに読む。
const currentBaseUrl = (): string => import.meta.env.BASE_URL || "/";

/**
 * 未認証（または再認証が必要）になったとき、ローカル開発ノードで開くべき戻り先を返す。
 * ローカルでなければ `null`（＝呼び出し側が従来どおり認証ポータルへ飛ばす）。
 *
 * PRODUCT_DEV-814: ローカルの `/vite/<product>/` から認証ポータルへ出すと、Portal は
 * `productId` で候補が 1 件に絞られるため自動リダイレクトし、戻り先は DDB Products の
 * `productUrl`＝**dev 環境の URL** になる。結果、ローカルのリンクを踏んだつもりが
 * dev 環境の画面がワンクリックで開いてしまう。ローカルに居るときは Portal へ出さず、
 * 同じノードの `/vite/` 一覧（nginx が返す静的ページ・Portal ログイン導線あり）へ戻す。
 *
 * `signin=1` は一覧側で「ログインが必要です」を出すための印。`location = /vite/` は
 * クエリ有無に関わらずマッチするので、nginx 側の設定変更は不要。
 */
export const resolveLocalViteSignInUrl = (
  pathname: string,
  origin: string,
  baseUrl: string = currentBaseUrl(),
): string | null =>
  baseUrl.startsWith("/vite/") && LOCAL_VITE_PATH.test(pathname)
    ? `${origin}/vite/?signin=1`
    : null;
